var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
export var useNavHeight = function () {
    var _a = useState(0), height = _a[0], setHeight = _a[1];
    useEffect(function () {
        window.addEventListener('fromFlutter', function (event) {
            var height = event.detail.height;
            setHeight(Math.floor(height));
        });
        if (window.toFlutter) {
            window.toFlutter.postMessage(JSON.stringify({ method: 'getStatusBarHeight' }));
        }
    }, []);
    return height;
};
var danaInfoCache = null;
var infoListenerBound = false;
var infoRequested = false;
var infoWaiters = new Map();
var bindInfoListener = function () {
    if (typeof window === 'undefined' || infoListenerBound) {
        return;
    }
    window.addEventListener('fromDanaFlutter', function (event) {
        var detail = event === null || event === void 0 ? void 0 : event.detail;
        console.log(detail, 'detail');
        if (detail && typeof detail === 'object') {
            danaInfoCache = __assign(__assign({}, (danaInfoCache || {})), detail);
            Object.keys(detail).forEach(function (key) {
                var waiters = infoWaiters.get(key);
                if (!(waiters === null || waiters === void 0 ? void 0 : waiters.length)) {
                    return;
                }
                waiters.forEach(function (resolve) { return resolve(detail[key]); });
                infoWaiters.delete(key);
            });
        }
    });
    infoListenerBound = true;
};
var requestInfoFromFlutter = function () {
    if (typeof window === 'undefined' || infoRequested) {
        return;
    }
    if (window.toFlutter) {
        window.toFlutter.postMessage(JSON.stringify({ method: 'info' }));
        infoRequested = true;
    }
};
export var getInfo = function (key) {
    var _a;
    bindInfoListener();
    requestInfoFromFlutter();
    return (_a = danaInfoCache === null || danaInfoCache === void 0 ? void 0 : danaInfoCache[key]) !== null && _a !== void 0 ? _a : null;
};
export var getInfoAsync = function (key, timeout) {
    if (timeout === void 0) { timeout = 1500; }
    var value = getInfo(key);
    if (value !== null && value !== undefined) {
        return Promise.resolve(value);
    }
    return new Promise(function (resolve) {
        var waiters = infoWaiters.get(key) || [];
        waiters.push(resolve);
        infoWaiters.set(key, waiters);
        setTimeout(function () {
            var _a, _b;
            var latestValue = (_a = danaInfoCache === null || danaInfoCache === void 0 ? void 0 : danaInfoCache[key]) !== null && _a !== void 0 ? _a : null;
            var currentWaiters = infoWaiters.get(key);
            if (currentWaiters === null || currentWaiters === void 0 ? void 0 : currentWaiters.includes(resolve)) {
                infoWaiters.set(key, currentWaiters.filter(function (waiter) { return waiter !== resolve; }));
                if (!((_b = infoWaiters.get(key)) === null || _b === void 0 ? void 0 : _b.length)) {
                    infoWaiters.delete(key);
                }
                resolve(latestValue);
            }
        }, timeout);
    });
};
export var goToRoom = function (uid) {
    if (window.toFlutter) {
        window.toFlutter.postMessage(JSON.stringify({
            method: 'commonNavigation',
            routhPath: "/room",
            uid: uid
        }));
    }
};
export var goToChat = function (uid) {
    if (window.toFlutter) {
        window.toFlutter.postMessage(JSON.stringify({
            method: 'commonNavigation',
            routhPath: "/messageChat",
            uid: uid
        }));
    }
};
